/**
 * AuditLine — componentă shared care afișează cine a înregistrat și cine a modificat
 * o intrare din DB (alimentare, alocare PSA, defect, document, etc).
 *
 * Sursa așteaptă un obiect cu câmpurile normalizate:
 *  - created_by_name (string) + created_at (ISO)
 *  - updated_by_name (string) + updated_at (ISO) — opțional
 *
 * Backend-ul trebuie să mapeze field-urile existente la aceste nume normalizate.
 */
import React from "react";

const fmtRoDateTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("ro-RO", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export function AuditLine({ entry, testid, compact = false, inline = false }) {
  if (!entry) return null;
  const c = entry.created_by_name;
  const u = entry.updated_by_name;
  const created = entry.created_at;
  const updated = entry.updated_at;
  if (!c && !u) return null;

  const sizeCls = compact ? "text-[10px]" : "text-[11px]";
  const wrapCls = inline ? "inline-flex flex-wrap gap-x-2 gap-y-0.5" : "space-y-px";

  return (
    <div className={`mt-0.5 ${sizeCls} text-zinc-400 leading-tight ${wrapCls}`} data-testid={testid}>
      {c && (
        <div className="flex items-center gap-1 truncate" title={`Înregistrat de ${c}${created ? ` la ${fmtRoDateTime(created)}` : ""}`}>
          <span className="text-zinc-500">📥</span>
          <span className="truncate">
            Înreg: <span className="text-zinc-600 font-medium">{c}</span>
            {created && <span className="text-zinc-400"> · {fmtRoDateTime(created)}</span>}
          </span>
        </div>
      )}
      {u && updated && updated !== created && (
        <div className="flex items-center gap-1 truncate text-amber-600" title={`Ultima modificare de ${u} la ${fmtRoDateTime(updated)}`}>
          <span>✏️</span>
          <span className="truncate">
            Modif: <span className="font-medium">{u}</span>
            <span className="text-amber-400"> · {fmtRoDateTime(updated)}</span>
          </span>
        </div>
      )}
    </div>
  );
}

export default AuditLine;
